<div class="sw-page">
  <div class="sw-content">
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />

    <div class="card shadow-sm rounded-3 p-3 mb-3 bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h2 class="mb-0">{{ ServiceName }}</h2>
          <p class="text-muted mb-0">Please select a sub-workflow to continue</p>
        </div>
        <div v-if="showSearchBar" class="sw-search-container ms-3">
          <i class="bi bi-search sw-search-icon"></i>
          <input type="text" class="sw-search-input" placeholder="Search for workflow" v-model="searchQuery">
        </div>
      </div>
    </div>

    <div class="sw-cards-container">
      <button v-for="(workflow, index) in paginatedWorkflows" 
              :key="index" 
              class="sw-card"
              :class="{ 'sw-card-completed': workflow.completed && !workflow.allow_multiple_onboarding }"
              @click="client_application_sub_workflow(workflow)"
              :disabled="workflow.completed && !workflow.allow_multiple_onboarding">
        <div class="sw-card-content">
          <div class="sw-card-left">
            <i v-if="workflow.completed && !workflow.allow_multiple_onboarding" class="bi bi-check-circle-fill sw-completed-icon"></i>
            <i v-else class="bi bi-info-circle sw-info-icon"></i>
            {{ workflow.router_name || workflow.service_name }}
            <span v-if="workflow.completed && !workflow.allow_multiple_onboarding" class="sw-completed-text">(Completed)</span>
          </div>
          <div class="sw-card-right">
            <i v-if="workflow.sub_workflow_type === 'external'" class="bi bi-box-arrow-up-right sw-chevron-icon"></i>
            <i v-else class="bi bi-chevron-right sw-chevron-icon"></i>
          </div>
        </div>
      </button>
    </div>

    <div>
      <button 
        type="submit" class="mt-5  btn bg-green btn-sm text-xs fw-bold rounded-pill" 
        @click="back_to_dashboard">
        Back to Dashboard
      </button>
    </div>
    
  </div>

  <div v-if="showSearchBar" class="sw-pagination-footer">
    <div class="sw-pagination-container">
      <button 
        class="sw-pagination-button sw-back-button" 
        :disabled="!canGoBack" 
        @click="previousPage">
        <i class="bi bi-chevron-left"></i> Back
      </button>
      
      <div class="sw-pagination-info">
        Page {{ currentPage }} of {{ totalPages }}
      </div>
      
      <button 
        class="sw-pagination-button sw-next-button" 
        :disabled="!canGoForward" 
        @click="nextPage">
        Next <i class="bi bi-chevron-right"></i>
      </button>
    </div>

  </div>

  

</div>